import { Table } from 'antd'
import { ButtonProps } from 'antd/lib/button'
import React, { FunctionComponent, memo, useMemo } from 'react'

import {
  AuctionLinkedPropertyRecord,
  AuctionLinkedPropertyTableView,
} from '../../../common/auctionMonitoringTypes'
import { priceEstimateSummaryStyle } from '../../utils/layoutConst'
import { useDeclension } from '../../utils/useDeclension'
import { AuctionMonitoringLinkedPropertyModalButton } from '../AuctionMonitoringLinkedPropertyModalButton/AuctionMonitoringLinkedPropertyModalButton'

export interface AuctionMonitoringLinkedPropertyTableSummaryProps {
  auctionId: string
  data: AuctionLinkedPropertyRecord[]
  viewType: AuctionLinkedPropertyTableView
}

const buttonProps: ButtonProps = {
  type: 'primary',
  className: '',
}

export const AuctionMonitoringLinkedPropertyTableSummary: FunctionComponent<AuctionMonitoringLinkedPropertyTableSummaryProps> =
  memo(props => {
    const { auctionId, data, viewType } = props
    const decline = useDeclension()

    const shouldDisplayButton = useMemo(() => viewType !== 'modal', [viewType])

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell
          className="text-gray-400 !border-b-0 border-gray-100 border-t"
          index={1}
          colSpan={3}
        >
          Celkem: {decline(data.length, 'property', true)}
        </Table.Summary.Cell>

        <Table.Summary.Cell
          className={priceEstimateSummaryStyle}
          index={2}
          colSpan={3}
        >
          {shouldDisplayButton && (
            <AuctionMonitoringLinkedPropertyModalButton
              auctionId={auctionId}
              propertyCount={0}
              buttonProps={buttonProps}
            />
          )}
        </Table.Summary.Cell>
      </Table.Summary.Row>
    )
  })
